module.exports = __webpack_public_path__ + "static/media/event-logo-707.22194c11.png";